"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.None = exports.Some = exports.Maybe = void 0;

var Maybe = /*#__PURE__*/function () {
  function Maybe() {
    _classCallCheck(this, Maybe);
  }

  _createClass(Maybe, null, [{
    key: "of",
    value: function of(value) {
      return value === undefined || value === null ? None.of() : Some.of(value);
    }
  }]);

  return Maybe;
}();

exports.Maybe = Maybe;

var Some = /*#__PURE__*/function () {
  function Some(value) {
    _classCallCheck(this, Some);

    this.value = value;
    this.isSome = true;
    this.isNone = false;
  }

  _createClass(Some, [{
    key: "map",
    value: function map(f) {
      return Maybe.of(f(this.value));
    }
  }, {
    key: "flatMap",
    value: function flatMap(f) {
      return f(this.value);
    }
  }, {
    key: "get",
    value: function get() {
      return this.value;
    }
  }, {
    key: "getOrElse",
    value: function getOrElse(_value) {
      return this.value;
    }
  }, {
    key: "defaulting",
    value: function defaulting(value) {
      return Maybe.of(this.getOrElse(value));
    }
  }], [{
    key: "of",
    value: function of(value) {
      if (value === null || value === undefined) {
        throw new Error('value is ${value}');
      }

      return new Some(value);
    }
  }]);

  return Some;
}();

exports.Some = Some;

var None = /*#__PURE__*/function () {
  function None() {
    _classCallCheck(this, None);

    this.isSome = false;
    this.isNone = true;
  }

  _createClass(None, [{
    key: "get",
    value: function get() {
      throw new Error('value is null');
    }
  }, {
    key: "getOrElse",
    value: function getOrElse(value) {
      return value;
    }
  }, {
    key: "map",
    value: function map(_f) {
      return new None();
    }
  }, {
    key: "flatMap",
    value: function flatMap(_f) {
      return new None();
    }
  }, {
    key: "defaulting",
    value: function defaulting(value) {
      return Maybe.of(this.getOrElse(value));
    }
  }], [{
    key: "of",
    value: function of() {
      return new None();
    }
  }]);

  return None;
}();

exports.None = None;